// const storedUser = localStorage.getItem('user');
// const user = JSON.parse(storedUser);

// export const API_URL = 'http://localhost:3006';
export const API_URL = 'https://srv702611.hstgr.cloud:3016';
export const token = () => sessionStorage.getItem('token');
export const userRole = () => sessionStorage.getItem('userRole');
// export const userId = localStorage.setItem('userId', user.user_id)
// export const API_URL = 'https://tantak-elearning.onrender.com';

// if(!token()) {
//     window.location.href = '/';
// }